import { render, staticRenderFns } from "./support.datatable.vue?vue&type=template&id=0ab62794&scoped=true&"
import script from "./support.datatable.vue?vue&type=script&lang=js&"
export * from "./support.datatable.vue?vue&type=script&lang=js&"
import style0 from "./support.datatable.vue?vue&type=style&index=0&id=0ab62794&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab62794",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
